import { CircleCheck, Info, OctagonAlert, TriangleAlert, type LucideIcon } from "lucide-react";
import type { AgvLog, LogSeverity } from "../types";
import { cn } from "@/lib/utils";
import { store } from "../../store";

export type LogItemProps = {
    log: AgvLog;
};

const statusConfig: Record<
    LogSeverity,
    { label: string; color: string; icon: LucideIcon; bg: string }
> = {
    info: { label: "Info", color: "text-blue-700", bg: "bg-blue-100", icon: Info },
    warning: { label: "Warning", color: "text-amber-700", bg: "bg-amber-100", icon: TriangleAlert },
    error: { label: "Error", color: "text-red-700", bg: "bg-red-100", icon: OctagonAlert },
    success: { label: "Success", color: "text-green-700", bg: "bg-green-50", icon: CircleCheck },
};

export const LogItem = ({ log }: LogItemProps): JSX.Element => {
    const status = statusConfig[log.severity];
    const Icon = status.icon;

    return (
        <div>
            <div className="text-muted-foreground mb-1 text-xs">
                {store.i18n.formatDateTime(log.createdAt, true)}
            </div>
            <div className="flex items-center gap-1">
                <div className={cn("rounded-md p-1", status.bg, status.color)}>
                    <Icon size={16} />
                </div>
                <div className={cn("truncate text-sm")}>{log.message}</div>
            </div>
        </div>
    );
};
